export enum CancellationSteps {
  Goodbye = 1,
  Reason = 2,
  Opinion = 3,
  Final = 4,
}
